import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, Alert } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useAuth } from "../contexts/AuthContext";

const { Title, Text } = Typography;

const demoUsers = [
  {
    label: "Super Admin",
    email: "superadmin@guardtour.com",
    password: "password123",
  },
  {
    label: "Multi Company",
    email: "multicompany@securesystem.com",
    password: "password123",
  },
  {
    label: "Admin",
    email: "admin@secureguard.com",
    password: "password123",
  },
  {
    label: "Supervisor",
    email: "supervisor@secureguard.com",
    password: "password123",
  },
  {
    label: "SafeWatch Owner",
    email: "admin@safewatch.com",
    password: "password123",
  },
  {
    label: "ProGuard Owner",
    email: "admin@proguard.com",
    password: "password123",
  },
];

const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();

  // const handleDemoClick = (email, password) => {
  //   form.setFieldsValue({ email, password });
  // };

  const handleSubmit = async (values) => {
    setLoading(true);
    setError("");

    try {
      const result = await login(values.email, values.password);

      if (!result.success) {
        setError(result.message);
      }
    } catch (error) {
      setError("เกิดข้อผิดพลาดที่ไม่คาดคิด");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
        }}
        bodyStyle={{ padding: "32px" }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src={process.env.PUBLIC_URL + "/android-chrome-192x192.png"}
            alt="PSG SecurePlus"
            style={{ width: 80, height: 80, marginBottom: 16 }}
          />
          <Title level={2} style={{ marginBottom: 4 }}>
            PSG SecurePlus
          </Title>
          <Text type="secondary">เข้าสู่ระบบผู้ดูแลระบบ</Text>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}

        <Form
          form={form}
          name="login"
          onFinish={handleSubmit}
          layout="vertical"
          requiredMark={false}
          initialValues={{
            email: "",
            password: "",
          }}
        >
          <Form.Item
            name="email"
            label="อีเมล"
            rules={[
              { required: true, message: "กรุณาระบุอีเมล" },
              { type: "email", message: "รูปแบบอีเมลไม่ถูกต้อง" },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="ระบุอีเมล"
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="รหัสผ่าน"
            rules={[
              { required: true, message: "กรุณาระบุรหัสผ่าน" },
              { min: 5, message: "รหัสผ่านต้องมีอย่างน้อย 5 ตัวอักษร" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="ระบุรหัสผ่าน"
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 32 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              เข้าสู่ระบบ
            </Button>
          </Form.Item>
        </Form>

        {/* <div style={{ textAlign: "center", marginTop: 24 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            ข้อมูลเข้าสู่ระบบสำหรับทดสอบ:
            <br />
            {demoUsers.map((user, idx) => (
              <div key={idx}>
                <a
                  onClick={() => handleDemoClick(user.email, user.password)}
                  style={{ color: "#1890ff", cursor: "pointer" }}
                >
                  {user.label}: {user.email}
                </a>{" "}
                / {user.password}
              </div>
            ))}
          </Text>
        </div> */}
      </Card>
    </div>
  );
};

export default Login;
